export const styles = theme => ({
  // Overlay fixo: o loading de rota renderiza dentro do <main> do shell, onde o
  // tema embedded forca `.block-ui { height: 100% !important }`. Ancorar no
  // viewport evita depender da altura resolvida pela cadeia de ancestrais.
  // O fundo nao fica aqui: quem pinta e a propria NimaLoadingSurface, com os
  // mesmos tokens da NIMA (marfim no claro, azul-noite no escuro).
  root: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
    display: 'flex',
  },
  surface: {
    flex: 1,
    minHeight: '100%',
  },
  errorPage: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%'
  }
});
